import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateCompanyChargeForm from "../../forms/CreateOrUpdateCompanyChargeForm";
import { CompanyChargeResponseDto } from "../../shared/dtos/companyCharge/CompanyChargeResponseDto";

interface UpdateCompanyChargeModalProps {
  open: boolean;
  onClose: () => void;
  companyCharge: CompanyChargeResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateCompanyChargeModal: React.FC<UpdateCompanyChargeModalProps> = ({
  open,
  onClose,
  companyCharge,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Charge: ${companyCharge.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateCompanyChargeForm
      isEditing={true}
      companyCharge={companyCharge}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateCompanyChargeModal;
